(function () {
  'use strict';

  angular.module('app.pages.dashboard')
      .controller('searchReportCtrl', searchReportCtrl);

  /** @ngInject */
  function searchReportCtrl($state, NgTableParams) {
    let vm = this;

    vm.tableParams = new NgTableParams({
      page: 1,
      count: 100
    }, {
      counts: [100,200],
      total: 0
      // ,
      // getData: function(params) {
      //   // ajax request to api
      //   return Parcels.list().then(function(data) {
      //     params.total(data.length); // recal. page nav controls
      //     return data;
      //   });
      // }
    });


    // default dropdown headers
    vm.reportTitle = "Choose a report";
    // vm.dateTitle = "Choose a date range";
    vm.formatTitle = "Choose a file format";
    vm.startDate = "Choose start date";

    vm.dateFormat = 'MM/dd/yyyy';

    vm.fileTypes = [
      ".csv",
      ".xlsx",
      ".pdf"
    ];



    vm.dateOptions = {
      //dateDisabled: disabled,
      formatYear: 'yyyy',
      maxDate: new Date(2020, 5, 22),
      minDate: new Date(),
      startingDay: 1
    };

    vm.popupStartDate = {
      opened: false
    };

    vm.popupEndDate = {
      opened: false
    };

    vm.openStart = function() {
        vm.popupStartDate.opened = true;
    };

    vm.openEnd = function() {
        vm.popupEndDate.opened = true;
    };

    vm.reportType = function(reporttype) {
      if (reporttype !== null ) {
        vm.reportTitle = reporttype;
      } else {
        vm.reportTitle = "Choose a report";
      }
    };

    vm.fileFormat = function(filetype) {
      if (filetype !== null ) {
        vm.formatTitle = filetype;
      } else {
        vm.formatTitle = "Choose a file format";
      }
    };

    vm.filterByDate = function(type, startDate, endDate) {
      let query = '';
      if (startDate == null && endDate != null) {
        query = type + " < '" + _formatDate(endDate) + "'"; // jshint ignore:line
      } else if (startDate != null && endDate == null) {
        query = type + " > '" + _formatDate(startDate) + "'"; // jshint ignore:line
      } else if (startDate == null && endDate == null) {
        query = '';
      } else {
        query = type + " > '" + _formatDate(startDate) + "' AND " + type + " < '" + _formatDate(endDate) + "'"; // jshint ignore:line
      }

      let queryObj = {};
      queryObj[type] = query;
      console.log(queryObj);
      // set the date query on the map service
      // maps.filterProperties(queryObj);
    };


    vm.clearSelections = function() {
      vm.reportTitle = "Choose a report";
      vm.dateTitle = "Choose a date range";
      vm.formatTitle = "Choose a file format";
    };

    vm.createReport = function() {
      console.log('creating report');
    };

    // function _formatDate(date) {
    //   return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    // }
  }
})();
